import { render, staticRenderFns } from "./AppointmentTypeCard.vue?vue&type=template&id=9c4a93ea&scoped=true"
import script from "./AppointmentTypeCard.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeCard.vue?vue&type=script&lang=js"
import style0 from "./AppointmentTypeCard.vue?vue&type=style&index=0&id=9c4a93ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4a93ea",
  null
  
)

export default component.exports